import PropTypes from 'prop-types';

const question = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  content: PropTypes.object,
  placeholder: PropTypes.string,
  href: PropTypes.string.isRequired
};

const formValue = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]).isRequired,
  error: PropTypes.bool.isRequired,
  isTouched: PropTypes.bool.isRequired
};

export const formErrorPropType = PropTypes.exact({
  href: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
});

const assetField = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  type: PropTypes.string.isRequired,
  is_required: PropTypes.bool,
  content: PropTypes.object,
  legacyShouldHideLabel: PropTypes.bool
};

// we only care about fields so we do this check with .shape
export const assetPropType = PropTypes.shape({
  fields: PropTypes.arrayOf(
    PropTypes.exact(assetField).isRequired
  ).isRequired
});

export const questionPropType = PropTypes.exact({
  ...question,
  legacyShouldHideLabel: PropTypes.bool
});
export const textQuestionPropType = PropTypes.exact({
  ...question,
  legacyShouldHideLabel: PropTypes.bool.isRequired
});
export const textareaQuestionPropType = PropTypes.exact(question);
export const checkboxQuestionPropType = PropTypes.exact({
  ...question,
  content: PropTypes.exact({
    options: PropTypes.arrayOf(
      PropTypes.exact({
        label: PropTypes.string.isRequired
      }).isRequired
    ).isRequired
  }).isRequired
});
export const radioQuestionPropType = PropTypes.exact({
  ...question,
  content: PropTypes.exact({
    options: PropTypes.arrayOf(
      PropTypes.exact({
        label: PropTypes.string.isRequired
      }).isRequired
    ).isRequired
  }).isRequired
});

export const formValuePropType = PropTypes.exact(formValue);
